import { useState } from "react";
import { IconClipboard, IconCheck } from "./icons";
import type { BadgeTone } from "../utils/status";

interface EntityMetaProps {
  /** Record id — omitted on "new" (create) forms. */
  id?: string;
  status?: { label: string; tone: BadgeTone };
}

// Id-chip (copy-to-clipboard) + status badge row for modal-form headers — the
// modal itself already shows the title and close button, so this is just the
// record-identity strip shown under it.
export const EntityMeta = ({ id, status }: EntityMetaProps) => {
  const [copied, setCopied] = useState(false);

  if (!id && !status) return null;

  const copyId = () => {
    if (!id) return;
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="entity-header__title-row" style={{ marginBottom: "1rem" }}>
      {id ? (
        <span className="id-chip">
          <span className="id-chip__value" title={id}>
            {id}
          </span>
          <button
            type="button"
            className={`id-chip__copy${copied ? " is-copied" : ""}`}
            aria-label="Copy ID"
            onClick={copyId}
          >
            {copied ? <IconCheck size={14} /> : <IconClipboard size={14} />}
          </button>
        </span>
      ) : null}
      {status ? (
        <span className={`badge badge--${status.tone}`}>
          <span className="badge__dot" />
          {status.label}
        </span>
      ) : null}
    </div>
  );
};
